import { useEffect } from "react";
import { usePostHog, useFeatureFlagEnabled } from "posthog-js/react";

/**
 * Flag-gated PostHog session replay (parity with iOS, which controls
 * posthog-react-native-session-replay via the `session_replay_enabled` feature
 * flag).
 *
 * PostHog is initialized with recording OFF (see main.tsx:
 * `disable_session_recording: true`), so posthog-js never auto-starts a replay
 * in the window before flags resolve. Recording is STARTED here only once the
 * `session_replay_enabled` flag is on for the user — controlled centrally from
 * PostHog, exactly like iOS. (Recording also requires Session Replay to be
 * enabled in the PostHog project settings.)
 *
 * Renders nothing; must live inside <PostHogProvider>.
 */
const REPLAY_FLAG = "session_replay_enabled";

export function SessionReplayGate(): null {
  const posthog = usePostHog();
  const enabled = useFeatureFlagEnabled(REPLAY_FLAG);

  useEffect(() => {
    if (!posthog) return;
    // `enabled` is undefined until flags resolve → treated as off.
    if (enabled) posthog.startSessionRecording();
    else posthog.stopSessionRecording();
  }, [posthog, enabled]);

  return null;
}

export default SessionReplayGate;
